import type React from "react";
import { createElement } from "react";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { StatefulDropdown } from "./StatefulDropdown";

import { SWWidget } from "app/components/widget/widget-types/widget.reg";

export interface IDynamicFilterProps {
    availableFilters: any;
    widgetFilters: any;
    changeFilter: (filter: any) => void;
    widgetMetric: string;
    widgetWebSource: string;
    widgetKeys: [];
    widgetDuration: string;
    widgetPreview: any;
    widgetCountry: number;
}

interface IDashboardWizardDynamicFiltersProps extends IDynamicFilterProps {
    widgetType: string;
}

const DashboardWizardDynamicFilters: React.FC<IDashboardWizardDynamicFiltersProps> = ({
    availableFilters,
    widgetFilters,
    changeFilter,
    widgetType,
    widgetMetric,
    widgetPreview,
    widgetKeys,
    widgetWebSource,
    widgetDuration,
    widgetCountry,
}) => {
    const onSelect = (filterName) => {
        return (item) => {
            changeFilter({
                ...item,
                name: filterName,
            });
        };
    };
    const widgetClass = SWWidget[`${widgetType}Widget`];
    const WidgetFiltersComponent =
        typeof widgetClass.getFiltersComponent === "function" ? widgetClass.getFiltersComponent() : false;
    const _filters = [];
    {
        Object.keys(availableFilters).forEach((filterName) => {
            //Show dynamic filter only if it has more than 1 select option.
            if (availableFilters[filterName].length > 1) {
                _filters.push(
                    <div
                        key={filterName}
                        className="dynamicFilter"
                    >
                        <h5>
                            <I18n>{`home.dashboards.wizard.filters.${filterName}`}</I18n>
                        </h5>
                        <StatefulDropdown
                            key={filterName}
                            items={availableFilters[filterName]}
                            selectedId={widgetFilters[filterName] ? widgetFilters[filterName].toString() : null}
                            onSelect={onSelect(filterName)}
                        />
                    </div>,
                );
            }
        });
    }
    // WidgetFiltersComponent is resolved dynamically from the widget type registry
    // (dozens of widget classes), so it can't be expressed as a static JSX tag.
    return WidgetFiltersComponent ? (
        createElement(WidgetFiltersComponent, {
            widgetPreview,
            widgetMetric,
            availableFilters,
            widgetFilters,
            changeFilter,
            widgetWebSource,
            widgetDuration,
            widgetKeys,
            widgetCountry,
        })
    ) : (
        <div
            key="dynamicFiltersContainer"
            className="filters"
        >
            {_filters}
        </div>
    );
};

export default DashboardWizardDynamicFilters;
